export enum WorkOrderAuditSituationType {
  ClosedWithoutFinancial = 'ClosedWithoutFinancial',
  ClosedWithLiquidValueDifferentFromFinancial = 'ClosedWithLiquidValueDifferentFromFinancial',
  ClosedWithoutCommission = 'ClosedWithoutCommission',
  ClosedWithCommissionGreaterThanService = 'ClosedWithCommissionGreaterThanService',
  ItemsWithSalePriceLowerThanCost = 'ItemsWithSalePriceLowerThanCost',
  ItemsWithZeroSaleOrUnitCost = 'ItemsWithZeroSaleOrUnitCost',
}

export enum WorkOrderAuditDataComplementsSituationType {
  ClosedWithoutFinancial = 'domain.enums.complement_situation_type.closed_without_financial',
  ClosedWithLiquidValueDifferentFromFinancial = 'domain.enums.complement_situation_type.closed_with_liquid_value_different_from_financial',
  ClosedWithoutCommission = 'domain.enums.complement_situation_type.closed_without_commission',
  ClosedWithCommissionGreaterThanService = 'domain.enums.complement_situation_type.closed_with_commission_greater_than_service',
}

export enum WorkOrderAuditDataSaleSituationType {
  SalesWithSalePriceLowerThanCost = 'domain.enums.sale_situation_type.sales_with_sale_price_lower_than_cost',
  SalesWithZeroRealPriceOrUnitCost = 'domain.enums.sale_situation_type.sales_with_zero_real_price_or_unit_cost',
}

export enum WorkOrderAuditDataComplementItemsSituationType {
  ItemsWithSalePriceLowerThanCost = 'domain.enums.items_situation_type.items_with_sale_price_lower_than_cost',
  ItemsWithZeroSaleOrUnitCost = 'domain.enums.items_situation_type.items_with_zero_sale_or_unit_cost',
}

export enum WorkOrderAuditItemTypes {
  Part = 1,
  Service = 2,
}
